module.exports = __webpack_public_path__ + "90a16005f0453fde837ba609f36e6278.svg";